import React from "react";

import {ISampleBaseModel} from "../models";

export const IsDraggingContext = React.createContext<boolean>(false);

export enum EDataRangedTab {
    None = 0,
    Basic = 1,
    Advanced = 2,
    Placeholder = 4,
    All = 7, // this will always be last, just convenient to get bitwise all.
}

export interface IDataRangedTable {
    headers: JSX.Element[];
    samples: IRangedSample[];
    dataTabs: EDataRangedTab[];
}

export interface IInvalidDataRangedTab {
    error: boolean;
    warning: boolean;
}

export interface ISortingType {
    active: string;
    ascending: boolean;
    applySort: (
        active: string,
        ascending: boolean,
        getValue: (sample: ISampleBaseModel) => number | string,
    ) => void;
}

export type IDataRangedHeader = (
    dataTab: EDataRangedTab,
    sort: ISortingType,
) => JSX.Element;
export type IDataRangedSample = (
    sample: ISampleBaseModel,
    dataTab: EDataRangedTab,
) => JSX.Element | null;
export type IRangedSample = (sample: ISampleBaseModel) => JSX.Element | null;
